export default "__VITE_ASSET__b81a21b9__"